module.exports = __webpack_public_path__ + "static/media/Time.401846e4.svg";